package com.solevo.dist.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.solevo.dist.navigation.Screen
import com.varabyte.kobweb.core.rememberPageContext
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseUser
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.first

@Composable
fun RequireAuth(content: @Composable () -> Unit) {
    val context = rememberPageContext()
    // Initialize with current user immediately (for persisted sessions)
    var user by remember { 
        mutableStateOf<FirebaseUser?>(Firebase.auth.currentUser)
    }
    var authChecked by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        // First check current user immediately
        val currentUser = Firebase.auth.currentUser
        if (currentUser != null) {
            user = currentUser
            authChecked = true
        }
        
        // Get the first auth state emission (this will be immediate if user is logged in)
        val initialAuthState = Firebase.auth.authStateChanged.first()
        user = initialAuthState
        authChecked = true
        
        if (initialAuthState == null) {
            println("User not authenticated, redirecting to login")
            context.router.navigateTo(Screen.Login.route)
        }
        
        // Then listen for subsequent auth state changes
        Firebase.auth.authStateChanged.collectLatest { u ->
            user = u
            if (u == null) {
                println("User logged out, redirecting to login")
                context.router.navigateTo(Screen.Login.route)
            }
        }
    }

    // Show content only if user is authenticated
    if (user != null && authChecked) {
        content()
    }
    // If authChecked is false, we're still checking - don't show anything yet
    // (This prevents flash of login screen when user is actually logged in)
}